/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/EndpointNameInput" />
import React = require("react");
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { InputDetails } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { InputDataType } from "ServiceEndpoints/Client/Contracts/FormInput_ServiceEndpoint";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ValidatedTextField } from "./ValidatedTextField";
import { IValidationProps } from "./IValidationProps";
import { ValidatedFormItem } from "./ValidatedFormItem";

export class EndpointNameInput extends VssComponent<IValidationProps> {

    private readonly _endpointEditorActionCreator: EndpointsEditorActionsCreator;
    private readonly _endpointEditorStore: EndpointsEditorStore;
    private readonly _validationDetails: InputDetails;
    private readonly _inputId = "endpoint-name";


    constructor(props: IValidationProps, context: IVssComponentContext) {
        super(props, context);

        this._endpointEditorActionCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        const endpoint = this._endpointEditorStore.getState().serviceEndpoint;

        this._validationDetails = {
            inputId: this._inputId,
            initialValue: endpoint.name,
            inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
            isConfidential: false,
            isUpdate: false
        };
    }

    public render(): JSX.Element {
        const endpoint = this._endpointEditorStore.getState().serviceEndpoint;

        return (<ValidatedFormItem
            inputId="endpoint-name"
            validationScopeId={this.props.validationScopeId}
            label={Resources.NameInputLabel}
            className="default-input-margin-top">
            <ValidatedTextField
                value={endpoint.name}
                onChange={this._onChange}
                validationDetails={this._validationDetails}
                validationScopeId={this.props.validationScopeId} />
        </ValidatedFormItem>);
    }

    private _onChange = (_: any, value: string) => {
        const endpoint = this._endpointEditorStore.getEndpointClone();
        endpoint.name = value;
        this._endpointEditorActionCreator.setServiceEndpoint(endpoint);
    }
}
